import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';
import { MANDATO_LISTING_TYPE } from '../../../config/configListing';

import css from './NoSearchResultsMaybe.module.css';

/**
 * FASE2-BUSCADOR-3d — El vacío y su CTA hablan del feed en el que estás.
 *
 * "No hemos encontrado negocios…" no encaja en /compradores, donde lo que se
 * lista son anuncios de compra. Y el CTA llevaba siempre a la bifurcación de
 * publicar: ahora va al wizard del tipo que corresponde, vía
 * /l/new?listingType=<tipo>, que es el mecanismo que ya existe.
 */
const NoSearchResultsMaybe = props => {
  const {
    listingsAreLoaded,
    totalItems,
    location,
    resetAll,
    showCreateListingsLink,
    listingType,
  } = props;
  const hasNoResult = listingsAreLoaded && totalItems === 0;
  const hasSearchParams = location.search?.length > 0;
  const esMandato = listingType === MANDATO_LISTING_TYPE;

  const createListingLinkMaybe = showCreateListingsLink ? (
    <NamedLink
      className={css.createListingLink}
      name="NewListingPage"
      to={listingType ? { search: `?listingType=${encodeURIComponent(listingType)}` } : undefined}
    >
      <FormattedMessage
        id={esMandato ? 'SearchPage.createListingCompradores' : 'SearchPage.createListingVenta'}
      />
    </NamedLink>
  ) : null;

  return hasNoResult ? (
    <div className={css.noSearchResults}>
      <FormattedMessage id={esMandato ? 'SearchPage.noResultsCompradores' : 'SearchPage.noResults'} />
      <br />
      {hasSearchParams ? (
        <button className={css.resetAllFiltersButton} onClick={e => resetAll(e)}>
          <FormattedMessage id={'SearchPage.resetAllFilters'} />
        </button>
      ) : null}
      <p>{createListingLinkMaybe}</p>
    </div>
  ) : null;
};

export default NoSearchResultsMaybe;
